import { UPDATE_WALKING_CIRCLE } from "./walkingCircleReducer"

export const updateWalkingCircle = (info) => ({
    type: UPDATE_WALKING_CIRCLE,
    payload: info
})